'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _contacts = require('redux/modules/contacts');

var _projects = require('selectors/projects');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _AddContactSuggestForm = require('components/AddContact/AddContactSuggestForm/AddContactSuggestForm');

var _AddContactSuggestForm2 = _interopRequireDefault(_AddContactSuggestForm);

var _contacts2 = require('selectors/contacts');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var AddRecipientField = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    addRecipientLoading: state.project.addRecipientLoading,
    addRecipientsFromGroupsLoading: state.project.addRecipientsFromGroupsLoading,
    groupsList: state.contacts.groupsListData,
    recipientsList: (0, _projects.getRecipients)(state),
    recipientsListLoading: state.project.recipientsListLoading,
    suggestionUsersList: (0, _contacts2.getSuggestionList)(state)
  };
}, (0, _extends3.default)({}, projectActions, { loadSuggestionUsersList: _contacts.loadSuggestionUsersList })), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(AddRecipientField, _Component);

  function AddRecipientField() {
    (0, _classCallCheck3.default)(this, AddRecipientField);
    return (0, _possibleConstructorReturn3.default)(this, (AddRecipientField.__proto__ || (0, _getPrototypeOf2.default)(AddRecipientField)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddRecipientField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadSuggestionUsersList();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var clearRecipientsList = this.props.clearRecipientsList;

      clearRecipientsList();
    }
  }, {
    key: 'onSuggestionSelected',
    value: function onSuggestionSelected(_ref) {
      var suggestion = _ref.suggestion;

      var user = {
        userEmail: suggestion.email,
        name: suggestion.name,
        surname: suggestion.surname
      };
      return suggestion._type === 'user' ? this.addRecipient(user) : this.addGroup(suggestion.id);
    }
  }, {
    key: 'getAutosuggestItems',
    value: function getAutosuggestItems() {
      var _props = this.props,
          suggestionUsersList = _props.suggestionUsersList,
          groupsList = _props.groupsList,
          hideGroups = _props.hideGroups;

      var items = [];
      if (!hideGroups) {
        groupsList.map(function (group) {
          return items.push((0, _extends3.default)({}, group, { _name: group.name, _type: 'group' }));
        });
      }
      suggestionUsersList.map(function (user) {
        return items.push((0, _extends3.default)({}, user, { _name: user.email, _type: 'user' }));
      });
      return items;
    }
  }, {
    key: 'addRecipient',
    value: function addRecipient(data) {
      var _props2 = this.props,
          projectId = _props2.projectId,
          onAdd = _props2.onAdd;


      var promise = this.props.addRecipient(projectId, data).promise;
      promise.then(function () {
        return onAdd();
      }).catch(function (err) {
        return err;
      });
      return promise;
    }
  }, {
    key: 'addGroup',
    value: function addGroup(groupId) {
      var _props3 = this.props,
          projectId = _props3.projectId,
          onAddGroup = _props3.onAddGroup;

      var promise = this.props.addRecipientsFromGroups(projectId, ['"' + groupId + '"']).promise;
      promise.then(function () {
        return onAddGroup();
      }).catch(function (err) {
        return err;
      });
      return promise;
    }
  }, {
    key: 'deleteRecipient',
    value: function deleteRecipient(recipient) {
      var projectId = this.props.projectId;

      return this.props.deleteRecipient(projectId, recipient.recipientId).promise;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          addRecipientLoading = _props4.addRecipientLoading,
          withTags = _props4.withTags,
          addRecipientsFromGroupsLoading = _props4.addRecipientsFromGroupsLoading,
          recipientsListLoading = _props4.recipientsListLoading,
          recipientsList = _props4.recipientsList,
          required = _props4.required;

      var emailsAndGroupsList = this.getAutosuggestItems();
      var showTagsLoader = withTags && (addRecipientLoading || addRecipientsFromGroupsLoading || recipientsListLoading);

      return _react2.default.createElement(_AddContactSuggestForm2.default, {
        onSuggestionSelected: this.onSuggestionSelected,
        withTags: withTags,
        onTagDelete: this.deleteRecipient,
        loading: showTagsLoader,
        onSubmit: this.onSubmit,
        items: emailsAndGroupsList,
        onAddNewContact: this.addRecipient,
        onAddNewContactLoading: addRecipientLoading,
        tags: recipientsList,
        required: required
      });
    }
  }]);
  return AddRecipientField;
}(_ClientSideComponent2.default), _class3.propTypes = {
  addRecipient: _propTypes2.default.func,
  addRecipientLoading: _propTypes2.default.bool,
  addRecipientsFromGroups: _propTypes2.default.func,
  addRecipientsFromGroupsLoading: _propTypes2.default.bool,
  clearRecipientsList: _propTypes2.default.func,
  deleteRecipient: _propTypes2.default.func,
  groupsList: _propTypes2.default.array,
  hideGroups: _propTypes2.default.bool,
  loadSuggestionUsersList: _propTypes2.default.func,
  onAdd: _propTypes2.default.func,
  onAddGroup: _propTypes2.default.func,
  projectId: _propTypes2.default.number.isRequired,
  recipientsList: _propTypes2.default.array,
  recipientsListLoading: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  suggestionUsersList: _propTypes2.default.array,
  withTags: _propTypes2.default.bool
}, _class3.defaultProps = {
  onAdd: _noop3.default,
  onAddGroup: _noop3.default,
  recipientsList: [],
  withTags: false
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSuggestionSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addRecipient', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addRecipient'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteRecipient', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteRecipient'), _class2.prototype)), _class2)) || _class);
exports.default = AddRecipientField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipients/AddRecipientField/AddRecipientField.js
// module id = 2083
// module chunks = 1